import React, { useEffect, useState } from "react";
import api from "@/lib/api";

export default function Announcements() {
  const [items, setItems] = useState([]);
  useEffect(() => {
    api.get("/announcements").then((r) => setItems(r.data.items || []));
  }, []);
  return (
    <div className="max-w-4xl">
      <div className="mb-8">
        <div className="gc-label mb-2">DUYURULAR</div>
        <h1 className="font-heading text-4xl md:text-5xl font-black">
          Sistem <span className="text-[#9D4EDD]">Notları</span>
        </h1>
      </div>
      <div className="space-y-4" data-testid="announcements-list">
        {items.length === 0 && (
          <div className="gc-card p-6 text-[#A1A1AA] text-sm">Henüz duyuru yok.</div>
        )}
        {items.map((a) => (
          <article
            key={a.id}
            className="gc-card p-5 border-l-2 border-l-[#EAB308]"
            data-testid="announcement-full"
          >
            <div className="flex items-center gap-2 mb-1">
              {a.pinned && <span className="gc-badge gc-badge-red">SABİT</span>}
              <span className="text-[10px] text-[#A1A1AA] font-mono">
                {a.created_at?.slice(0, 16).replace("T", " ")}
              </span>
            </div>
            <h2 className="font-heading text-2xl font-bold">{a.title}</h2>
            <p className="text-sm text-[#EDEDED] mt-2 whitespace-pre-wrap">{a.body}</p>
          </article>
        ))}
      </div>
    </div>
  );
}
